import { render, staticRenderFns } from "./MandellsTable.vue?vue&type=template&id=efba718e&scoped=true"
import script from "./MandellsTable.vue?vue&type=script&lang=js"
export * from "./MandellsTable.vue?vue&type=script&lang=js"
import style0 from "./MandellsTable.vue?vue&type=style&index=0&id=efba718e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "efba718e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDataTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VDataTable})
